import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

@Component({
    selector: 'applicant-notifications',
    templateUrl: './applicant-notifications.component.html',
    standalone: true,
    imports: [NgClass, TooltipModule, SpanTooltipComponent, AfOrderByPipe, AfTranslatePipe, ConvertDatePipe, AfTranslateDirective]
})
export class ApplicantNotificationsComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  isLanding: Boolean = this.customLanding.isLanding();
  userPermissions: any = this.permissions.getPermissions();
  applicantNotifications: any = {
    showTemplate: false,
    fullScreen: false,
  }
  constructor(private globalCfg: GlobalCfgFactory,
    private permissions: UserPermisionsFactory,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private modalService: ModalServiceService,
    private customLanding: CustomLandingFactory) {}

  @Input() concept:any = null;
  @Output() generateDocument = new EventEmitter();

  ngOnInit(): void {
    this.getAnsweredQueries();
  }

  getAnsweredQueries() {
    if (this.concept?.conceptObjectId) {
      this.apiService.get('notifications/public-alert-process/conceptobject', this.concept?.conceptObjectId)
        .then((data:any)=>{
          this.applicantNotifications.notificationList = data;
          if(data.length){
            this.applicantNotifications.showTemplate = true;
          }
      }, (error:any)=>{})
    }
  }

  showNotification(notification:any){
    if(this.userPermissions !== 'none'){
      this.modalService.notificationPreview({notification: notification, type: 'public-alert-process'});
    }
  }

  reSendNotification(notification:any, e:any){
    e.stopPropagation();
    this.apiService.add('notifications/public-alert-process/notification/'+notification.alertNotificationId+'/resend', {})
      .then((data:any)=>{
        this.applicantNotifications.notificationList.push(data);
        this.modalService.successModal({ text: this.translate.instant('icam-queries.confirm-resend') });
      })
  }
}
